import React, { useState, useRef } from "react";
import GenericModal from "../../../buttons/genericModal";
import { Form, Input, message } from "antd";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { backendPostWithoutRefresh } from "../../../../helpers/callBackend";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import theme from "../../../../helpers/theme";

const AddEntityDetailsButton = (props) => {
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();

    const formRef = useRef(null);

    const onFormSubmitModal = (values) => {
        setSubmitting(true);
        const data = {
            entity_names: values.entities.map(item => item.entity_name)
        };
        backendPostWithoutRefresh("/api/entity/", data)
            .then((res) => {
                if (formRef.current) {
                    formRef.current.resetFields();
                }
                props.addEntities(res.data.new_entities);
                setSubmitting(false);
                setVisible(false);
            })
            .catch((err) => {
                setSubmitting(false);
                message.error(err.response.data.message);
            })
    }

    const handlePaste = (e, add, fields) => {
        e.preventDefault();
        const existingFields = form.getFieldsValue();
        const existingFieldsArray = existingFields['entities'];
        const pastedData = e.clipboardData.getData('text');
        const pastedDataArray = pastedData.split(/[\t\n]+/).filter(item => item.trim() !== '').map((item) => ({ entity_name: item }));
        const newFieldsArray = pastedDataArray.concat(existingFieldsArray).filter((item) => item.entity_name)
        const newFormFields = {};
        newFormFields['entities'] = newFieldsArray
        form.setFieldsValue(newFormFields)
    };

    return (
        <GenericModal
            visible={visible}
            handleCancelModal={() => {
                if (formRef.current) {
                    formRef.current.resetFields();
                }
                setVisible(false);
                setSubmitting(false);
            }}
            showModal={() => {
                setVisible(true);
                setSubmitting(false);
            }}
            size='sm'
            button={
                <Button disableElevation fullWidth size="small" variant="contained" color="primary" sx={{ fontSize: 14, width: '100%', textTransform: 'none', minWidth: "max-content" }}>
                    {props.buttonTitle}
                </Button>
            }
            modalTitle={'Add New Entity'}
            modalBody={
                <Form
                    layout="vertical"
                    name="basic"
                    onFinish={onFormSubmitModal}
                    autoComplete="off"
                    initialValues={{ entities: [{ entity_name: "" }] }}
                    ref={formRef}
                    form={form}
                >
                    <Form.List name="entities" form={form}>
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(field => (
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'entity_name']}
                                        fieldKey={[field.fieldKey, 'entity_name']}
                                        rules={[{ required: true, message: 'Please input Entity name or delete this field.' }]}
                                        style={{ flex: 1 }}
                                    >
                                        <Input placeholder="Entity Name" style={{ width: '100%' }}
                                            addonAfter={fields.length > 1 ? (
                                                <MinusCircleOutlined
                                                    className="dynamic-delete-button"
                                                    onClick={() => remove(field.name)}
                                                />
                                            ) : undefined}
                                            onPaste={(e) => handlePaste(e, add, fields)}
                                        />
                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Button disableElevation fullWidth size="small" color="secondary" sx={{ fontSize: 14, width: '100%', textTransform: 'none', border: `1px dashed ${theme.palette.secondary.light}` }} onClick={() => add()} block icon={<PlusOutlined />}>
                                        Add Row
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                    <Form.Item>
                        <LoadingButton
                            type="primary"
                            htmlType="submit"
                            style={{ marginTop: "-10px", width: "100%" }}
                            loading={submitting} loadingPosition="start"
                            disableElevation fullWidth size="small" variant="contained" color="primary"
                            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                        >
                            Submit
                        </LoadingButton>
                    </Form.Item>
                </Form>
            }
        />
    );
};

export default AddEntityDetailsButton;
